import { useCallback } from 'react';
import { prop } from 'ramda';
import { useAppSelector } from 'js/store/hooks';
import { getPlayerTags, getTwoFactorConf } from 'js/hooks/user/server';

import { TWO_FACTOR_AUTH_TAGS } from '../constants';

const get2FAConf = async (casinoName) => {
    const response = await getTwoFactorConf({ casinoName });

    return response?.data?.twoFactorConf || {};
};

const get2FAPlayerTags = async () => {
    const response = await getPlayerTags(Object.values(TWO_FACTOR_AUTH_TAGS).join(','));
    const tags = response?.data?.tags || [];

    return tags.filter(({ name }) => Object.values(TWO_FACTOR_AUTH_TAGS).includes(name));
};

export const useFetchPreferences = () => {
    const casinoName = useAppSelector(prop('casinoName'));

    return useCallback(() => Promise.all([get2FAConf(casinoName), get2FAPlayerTags()]), [casinoName]);
};
